import { useCallback } from "react";
import { useStoreAppValue } from "@hooks/context/storeAppContext";
import { Bugsnag } from "@services";

// == Types ================================================================

// == Constants ============================================================

// == Hooks ================================================================

export function useRecaptcha({ action }: { action: string }) {
  const { recaptchaEnterpriseKey } = useStoreAppValue();

  return useCallback(() => {
    return new Promise((resolve, reject) => {
      try {
        window.grecaptcha.enterprise.ready(() => {
          window.grecaptcha.enterprise
            .execute(recaptchaEnterpriseKey, { action })
            .then((token) => {
              resolve(token);
            })
            .catch((error) => {
              Bugsnag.notify(error);
              reject(error);
            });
        });
      } catch (error) {
        Bugsnag.notify(error);
        reject(error);
      }
    });
  }, [action]);
}

